<template>
    <header class="header header--fixed" v-scroll="fixedScroll">
        <!-- S: body -->
        <div class="header__body">
            <v-container>
                <h1 class="header__logo">
                    <router-link to="/ko" title="홈으로 이동"><span class="d-sr-only">KIE</span></router-link>
                </h1>
                <div class="header__contents">
                    <div class="header__gnb justify-center">
                        <!-- S: Gnb -->
                        <client-gnb className="gnb"></client-gnb>
                        <!-- E: Gnb -->
                    </div>
                    <!-- S: Header Right -->

                    <div class="align-center d-none d-xl-flex header-right">
                        <router-link to="/ko/contactus">
                            <v-btn x-large rounded class="color-white font-weight-bold font-size-16 min-w-200px quick-button">
                                <span>Contact US</span>
                            </v-btn>
                        </router-link>

                        <div class="lang-wrap mx-14">
                            <button class="d-block lang-btn pa-2"></button>
                            <ul class="lang">
                                <li><router-link to="/">ENG</router-link></li>
                                <li class="on">KOR</li>
                            </ul>
                        </div>

                        <div class="hamburger-btn-pc"></div>
                    </div>
                    <!-- E: Header Right -->
                    <!-- S: 모바일 user-menu -->
                    <div class="user-menu--moblie d-flex d-xl-none align-center justify-center">
                        <router-link to="/" class="d-block mx-16">ENG</router-link>

                        <router-link to="/ko/contactus">
                            <v-btn x-large rounded color="primary" class="color-white font-weight-bold font-size-16 px-20 min-w-180px">
                                <span>Contact US</span>
                            </v-btn>
                        </router-link>
                    </div>
                    <!-- E: 모바일 user-menu -->
                </div>
            </v-container>
        </div>
        <!-- E: body -->

        <!-- S: hamburger -->
        <div class="hamburger-btn">
            <span></span>
        </div>
        <!-- E: hamburger -->

        <!-- S: Side gnb -->
        <div class="side-gnb-wrap">
            <v-container>
                <v-expansion-panels>
                    <v-row align="center">
                        <v-col cols="6">
                            <ul class="slide-gnb__menu slide-gnb__menu1">
                                <li class="slide-gnb__menu-toggle">
                                    <v-expansion-panel class="dep2_li">
                                        <v-expansion-panel-header>
                                            <h2 class="slide-gnb__1depth">
                                                <span>About us</span>
                                                <div class="toggle-icon"></div>
                                            </h2>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <ul class="slid-gnb__sub-ul">
                                                <li>
                                                    <router-link to="/ko/aboutus/company-profile" @click.native="slidGnbSubLinkClick">회사 프로필</router-link>
                                                </li>
                                                <li>
                                                    <router-link to="/ko/aboutus/certificate" @click.native="slidGnbSubLinkClick">인증서</router-link>
                                                </li>
                                                <li>
                                                    <router-link to="/ko/aboutus/organization" @click.native="slidGnbSubLinkClick">조직도</router-link>
                                                </li>
                                                <li>
                                                    <router-link to="/ko/aboutus/location/paju" @click.native="slidGnbSubLinkClick">위치</router-link>
                                                </li>
                                            </ul>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </li>
                                <li>
                                    <v-expansion-panel class="dep2_li">
                                        <v-expansion-panel-header>
                                            <h2 class="slide-gnb__1depth">
                                                <span>Product</span>
                                                <div class="toggle-icon"></div>
                                            </h2>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <ul class="slid-gnb__sub-ul">
                                                <li>
                                                    <router-link to="/ko/product/Analyzer" @click.native="slidGnbSubLinkClick">분석기 시스템</router-link>
                                                </li>
                                                <li>
                                                    <router-link to="/ko/product/CEMS" @click.native="slidGnbSubLinkClick">CEMS / AQMS</router-link>
                                                </li>
                                                <li>
                                                    <router-link to="/ko/product/Liquid" @click.native="slidGnbSubLinkClick">액체 분석기 시스템</router-link>
                                                </li>
                                                <li>
                                                    <router-link to="/ko/product/Sampling" @click.native="slidGnbSubLinkClick">샘플링 시스템</router-link>
                                                </li>
                                                <li>
                                                    <router-link to="/ko/product/Corrosion" @click.native="slidGnbSubLinkClick">부식 모니터링 시스템</router-link>
                                                </li>
                                            </ul>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </li>
                                <li>
                                    <v-expansion-panel class="dep2_li">
                                        <v-expansion-panel-header>
                                            <h2 class="slide-gnb__1depth">
                                                <span>Project / Reference</span>
                                                <div class="toggle-icon"></div>
                                            </h2>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <ul class="slid-gnb__sub-ul">
                                                <li>
                                                    <router-link to="/ko/project" @click.native="slidGnbSubLinkClick">Project</router-link>
                                                </li>
                                                <li>
                                                    <router-link to="/ko/reference" @click.native="slidGnbSubLinkClick">Reference</router-link>
                                                </li>
                                            </ul>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </li>
                            </ul>
                        </v-col>
                        <v-col cols="6">
                            <ul class="slide-gnb__menu slide-gnb__menu2">
                                <li class="slide-gnb__menu-toggle">
                                    <v-expansion-panel class="dep2_li">
                                        <v-expansion-panel-header>
                                            <h2 class="slide-gnb__1depth">
                                                <span>Alliance</span>
                                                <div class="toggle-icon"></div>
                                            </h2>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <ul class="slid-gnb__sub-ul">
                                                <li>
                                                    <router-link to="/ko/alliance/#abb" @click.native="slidGnbSubLinkClick">ABB</router-link>
                                                </li>
                                                <li>
                                                    <router-link to="/ko/alliance/#teledyne" @click.native="slidGnbSubLinkClick">TELEDYNE</router-link>
                                                </li>
                                                <li>
                                                    <router-link to="/ko/alliance/#pac" @click.native="slidGnbSubLinkClick">PAC</router-link>
                                                </li>
                                                <li>
                                                    <router-link to="/ko/alliance/#metal" @click.native="slidGnbSubLinkClick">Metal Samples</router-link>
                                                </li>
                                                <li>
                                                    <router-link to="/ko/alliance/#extrel" @click.native="slidGnbSubLinkClick">EXTREL</router-link>
                                                </li>
                                            </ul>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </li>
                                <li>
                                    <router-link to="/ko/contactus" class="slide-gnb__1depth" @click.native="slidGnbSubLinkClick">Contact US</router-link>
                                </li>
                            </ul>
                        </v-col>
                    </v-row>
                </v-expansion-panels>
            </v-container>
        </div>
        <!-- E: Side gnb -->
    </header>
</template>

<script>
import ClientGnb from "@/components/client/ko/inc/client-gnb.vue";
import UserMenu from "@/components/client/ko/inc/user-menu.vue";
import LocaleSelect from "@/components/client/ko/inc/locale-select.vue";
import MainHeaderSearch from "./main-header-search.vue";
import axios from "@/plugins/axios";

export default {
    components: {
        ClientGnb,
        UserMenu,
        LocaleSelect,
        MainHeaderSearch,
    },
    data() {
        return {
            window: {
                width: 0,
                height: 0,
            },
            dialog: false,
            language: "ko",
        };
    },
    mounted() {
        window.scrollTo(0, 0); // 라우터 이동 시 스크롤 상단부터 시작

        if (this.isDesktop) {
            this.initPcEvent();
        }
        if (this.isMobile) {
            this.initMobileEvent();
        }
    },
    methods: {
        fixedScroll: function() {
            var header = document.querySelector(".header");
            var scrollTop = window.scrollY || document.documentElement.scrollTop;

            if (scrollTop > 50) {
                header.classList.add("scroll-active");
            } else {
                header.classList.remove("scroll-active");
            }
        },
        handleResize: function() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        slidGnbSubLinkClick: function() {
            var HTML = document.querySelector("html");
            var header = document.querySelector(".header");
            var slideGnbToggle = document.querySelectorAll(".slide-gnb__menu-toggle .dep2_li");
            var slideGnbBtn = document.querySelectorAll(".slide-gnb__menu-toggle .dep2_li .v-expansion-panel-header");

            HTML.classList.remove("pc-menu-hidden");
            header.classList.remove("pc-menu-on");

            slideGnbToggle.forEach(function(el) {
                el.classList.remove("v-expansion-panel--active");
                el.classList.remove("v-item--active");
                el.setAttribute("aria-expanded", "false");
            });
            slideGnbBtn.forEach(function(el) {
                el.classList.remove("v-expansion-panel-header--active");
                el.setAttribute("aria-expanded", "false");
            });
        },
        // PC
        initPcEvent: function() {
            // gnb
            var lis = document.getElementsByClassName("gnb__li");
            for (var i = 0; i < lis.length; i++) {
                lis[i].addEventListener("mouseenter", gnbLiOver);
                lis[i].addEventListener("mouseleave", gnbLiOut);
            }
            var gnb = document.querySelector(".gnb");
            gnb.addEventListener("mouseenter", gnbOver);
            gnb.addEventListener("mouseleave", gnbOut);

            // lang
            var lang = document.querySelector(".lang-wrap");
            lang.addEventListener("click", langBox);

            // hamburgerBtnPc
            var hamburgerBtnPc = document.querySelector(".hamburger-btn-pc");
            hamburgerBtnPc.addEventListener("click", pcMenuToggle);
        },
        destroyPcEvent: function() {
            // gnb
            var lis = document.getElementsByClassName("gnb__li");
            for (var i = 0; i < lis.length; i++) {
                lis[i].removeEventListener("mouseenter", gnbLiOver);
                lis[i].removeEventListener("mouseleave", gnbLiOut);
            }
            var gnb = document.querySelector(".gnb");
            gnb.removeEventListener("mouseenter", gnbOver);
            gnb.removeEventListener("mouseleave", gnbOut);

            // lang
            var lang = document.querySelector(".lang-wrap");
            lang.removeEventListener("click", langBox);
            lang.classList.remove("active");

            // hamburgerBtnPc
            var hamburgerBtnPc = document.querySelector(".hamburger-btn-pc");
            hamburgerBtnPc.removeEventListener("click", pcMenuToggle);
        },
        // Mobile
        initMobileEvent: function() {
            // hamburgerBtn
            var hamburgerBtn = document.querySelector(".hamburger-btn");
            hamburgerBtn.addEventListener("click", mobileMenuToggle);

            // gnb
            var gnbLinkToggle = document.querySelectorAll(".gnb__link--toggle");
            gnbLinkToggle.forEach(function(el) {
                el.addEventListener("click", toggleAccordion);
            });

            // gnb sub
            var gnbSubLink = document.querySelectorAll(".gnb__sub >li >a");
            gnbSubLink.forEach(function(el) {
                el.addEventListener("click", gnbSubLinkClick);
            });
        },
        destroyMobileEvent: function() {
            // hamburgerBtn
            var hamburgerBtn = document.querySelector(".hamburger-btn");
            hamburgerBtn.removeEventListener("click", mobileMenuToggle);

            // gnb
            var gnbLinkToggle = document.querySelectorAll(".gnb__link--toggle");
            gnbLinkToggle.forEach(function(el) {
                el.removeEventListener("click", toggleAccordion);
            });

            // gnb sub
            var gnbSubLink = document.querySelectorAll(".gnb__sub >li >a");
            gnbSubLink.forEach(function(el) {
                el.removeEventListener("click", gnbSubLinkClick);
            });
        },
    },
    computed: {
        isDesktop: function() {
            return this.window.width >= 1200;
        },
        isMobile: function() {
            return this.window.width < 1200;
        },
    },
    created() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
        if (this.isDesktop) {
            this.destroyPcEvent();
        }
        if (this.isMobile) {
            this.destroyMobileEvent();
        }
    },
    watch: {
        isDesktop: function() {
            if (this.isDesktop) {
                this.initPcEvent();
            } else {
                this.destroyPcEvent();
            }
        },
        isMobile: function() {
            if (this.isMobile) {
                this.initMobileEvent();
            } else {
                this.destroyMobileEvent();
            }
        },
    },
};

// PC
function gnbLiOver() {
    var headerBg = document.querySelector(".header__bg");
    var gnbSub = this.querySelector(".gnb__sub");

    this.classList.add("active");
    if (gnbSub == null) {
        headerBg.classList.add("none");
    }
}
function gnbLiOut() {
    var headerBg = document.querySelector(".header__bg");
    var gnbSub = this.querySelector(".gnb__sub");

    this.classList.remove("active");
    if (gnbSub == null) {
        headerBg.classList.remove("none");
    }
}
function gnbOver() {
    var header = document.querySelector(".header");
    header.classList.add("menu-active");
}
function gnbOut() {
    var header = document.querySelector(".header");
    header.classList.remove("menu-active");
}
function langBox() {
    var lang = document.querySelector(".lang-wrap");
    lang.classList.toggle("active");
}
function pcMenuToggle() {
    var HTML = document.querySelector("html");
    var header = document.querySelector(".header");
    var slideGnbToggle = document.querySelectorAll(".slide-gnb__menu-toggle .dep2_li");
    var slideGnbBtn = document.querySelectorAll(".slide-gnb__menu-toggle .dep2_li .v-expansion-panel-header");

    header.classList.toggle("pc-menu-on");
    HTML.classList.toggle("pc-menu-hidden");

    slideGnbToggle.forEach(function(el) {
        el.classList.remove("v-expansion-panel--active");
        el.classList.remove("v-item--active");
        el.setAttribute("aria-expanded", "false");
    });
    slideGnbBtn.forEach(function(el) {
        el.classList.remove("v-expansion-panel-header--active");
        el.setAttribute("aria-expanded", "false");
    });
}

// Mobile
function mobileMenuToggle() {
    var HTML = document.querySelector("html");
    var header = document.querySelector(".header");
    var gnbLinkToggle = document.querySelectorAll(".gnb__link--toggle");

    header.classList.toggle("mobile-menu-on");
    // HTML.classList.toggle('hidden');

    if (header.classList.contains("mobile-menu-on")) {
        gnbLinkToggle.forEach(function(el) {
            el.parentNode.classList.remove("active");
        });
    }
}
function toggleAccordion(el) {
    var gnbLinkToggle = document.querySelectorAll(".gnb__link--toggle");
    var targetLi = el.currentTarget.parentNode.classList;
    var target = el.currentTarget;

    el.preventDefault();
    if (targetLi.contains("active")) {
        targetLi.remove("active");
    } else {
        gnbLinkToggle.forEach(function(el) {
            el.parentNode.classList.remove("active");
        });
        targetLi.add("active");
    }
}
function gnbSubLinkClick(el) {
    var header = document.querySelector(".header");
    var gnbLinkToggle = document.querySelectorAll(".gnb__link--toggle");

    header.classList.remove("mobile-menu-on");
    if (header.classList.contains("mobile-menu-on")) {
        gnbLinkToggle.forEach(function(el) {
            el.parentNode.classList.remove("active");
        });
    }
}
</script>
